import { render, staticRenderFns } from "./base-asset.vue?vue&type=template&id=7196e667&scoped=true"
import script from "./base-asset.vue?vue&type=script&lang=js"
export * from "./base-asset.vue?vue&type=script&lang=js"
import style0 from "./base-asset.vue?vue&type=style&index=0&id=7196e667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196e667",
  null
  
)

export default component.exports